module.exports = __webpack_public_path__ + "assets/888cfed57fd89e46acc1e1d928a2649e.mp3";